import { httpClient } from '@/clients/http';
import { getCategoryUrl } from '@/services/top5-v2-1/utils/get-category-url';
import {
    Top521HomePageReview,
    Top5V21Category,
    Top5V21CategoryResponse,
    Top5V21Partner,
    Top5V21PartnerSet,
    Top5V21PartnersReview,
} from './http-response-types';

type GetCategoryResponse = {
    bannerPartner: Top5V21Partner;
    category: Top5V21Category;
    partners: Top5V21Partner[];
    partnerSet: Top5V21PartnerSet;
    pageViewId: string;
    partnersReview: Top5V21PartnersReview[];
    partnersCount: number;
    homePageReview: Top521HomePageReview;
    sidebar_billboard_partner?: object;
};

type GetCategoryUrlArgs = {
    hasAbRank?: boolean;
    fixedPosition?: boolean;
    boostRankingVersion?: string;
    boostRanking?: string;
    category: string;
    start: string;
    length: string;
    sidebar_billboard_partner?: object;
};

export async function getCategory(
    args: GetCategoryUrlArgs
): Promise<GetCategoryResponse> {
    const { body } = await httpClient.get<Top5V21CategoryResponse>({
        url: `${window.__api_base_url__ + '_1'}${getCategoryUrl(args)}`,
    });

    return {
        bannerPartner: body.banner_partner || body.partners[0],
        category: body.category,
        partners: body.partners,
        partnerSet: body.partnerSet,
        pageViewId: body.page_view_id,
        partnersReview: body.partners_review,
        partnersCount: body.partners_count || 0,
        homePageReview: body.home_page_review,
        sidebar_billboard_partner: body.sidebar_billboard_partner || null,
    };
}
